<template>
  <svg width="30" height="24" viewBox="0 0 30 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M0.0575678 6C0.129411 4.82336 0.290912 3.98858 0.653961 3.27606C1.2292 2.14708 2.14708 1.2292 3.27606 0.653961C4.55953 0 6.23969 0 9.6 0H20.4C23.7603 0 25.4405 0 26.7239 0.653961C27.8529 1.2292 28.7708 2.14708 29.346 3.27606C29.7091 3.98858 29.8706 4.82336 29.9424 6H0.0575678ZM0 12H30V14.4C30 17.7603 30 19.4405 29.346 20.7239C28.7708 21.8529 27.8529 22.7708 26.7239 23.346C25.4405 24 23.7603 24 20.4 24H9.6C6.23969 24 4.55953 24 3.27606 23.346C2.14708 22.7708 1.2292 21.8529 0.653961 20.7239C0 19.4405 0 17.7603 0 14.4V12ZM23 14.5715C21.3431 14.5715 20 15.9147 20 17.5715C20 19.2284 21.3431 20.5715 23 20.5715H24.5C26.1568 20.5715 27.5 19.2284 27.5 17.5715C27.5 15.9147 26.1568 14.5715 24.5 14.5715H23Z" fill="#453D4C"/>
  </svg>
</template>

<script>
export default {
  name: 'card-icon'
}
</script>
